import React, { useEffect, useState } from "react";
import io from "socket.io-client";
import { SOCKET_URL } from "../../config";

export const SocketContext = React.createContext<{
  socket: SocketIOClient.Socket | null;
}>({ socket: null });

interface SocketProviderProps {
  children: React.ReactNode;
}

export const SocketProvider: React.FC<SocketProviderProps> = ({ children }) => {
  const [socket, setSocket] = useState<SocketIOClient.Socket | null>(null);

  useEffect(() => {
    const socketInstance = io.connect(SOCKET_URL);
    setSocket(socketInstance);

    return () => {
      socketInstance.disconnect();
    };
  }, []);

  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};

export default SocketContext;
